import { useContext, useEffect, useRef, useState } from "react";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import "../../../../styles/workspace_styles/CustomerAdministratorStyles/Dashboards/Dashboards.css";
import { LoadShortDate } from "../../../../functions/LoadShortDate";
import { LoadShortTime } from "../../../../functions/LoadShortTime";
import { AppContext } from "../../../AppProvider";
import CustomerAdministratorSideBar from "../../../sidebar_components/CustomerAdministratorSideBar";
import NavigationBar from "../../../navigation_components/NavigationBar";
import { useNavigate } from "react-router-dom";
import { DashboardContext } from "./DashboardProvider";
const DashboardsTable = ({
    dashboardsCurrentPage,
    dashboardsPageLimit,
}) => {
    const {
        dashboardSummaries
    } = useContext(DashboardContext);
    const {customerIotProfile} = useContext(AppContext);
    const navigate = useNavigate();
    const extractAssignedCustomersString = (customers) =>{
        return customers.filter(c => c?.name?.length > 0).map(c => c.name).join(', ');
    };
    if(!Array.isArray(dashboardSummaries) || dashboardSummaries.length === 0) return(
        <div className="customer-administrator-loading-dashboards-mask">
            <div className="customer-administrator-loading-dashboards-mask-spinner"></div>
            <p>Loading dashboards, please wait...</p>
        </div>
    );
    return(
        <div className="customer-admin-dashboards-table-container">
            <table className="customer-admin-dashboards-table">
                <thead>
                    <tr id="customer-admin-dashboards-table-header-row">
                        <th style={{width:'20%'}}>Created time</th>
                        <th style={{width:'20%'}}>Title</th>
                    </tr>
                </thead>
                <tbody>
                    {dashboardSummaries && dashboardSummaries.slice((((dashboardsCurrentPage - 1) * dashboardsPageLimit)),(dashboardsCurrentPage * dashboardsPageLimit)).map(dashboardSummary =>{
                        return(
                            <tr key={dashboardSummary?.id} onClick={async() =>{
                                navigate(`/customers/admin/${customerIotProfile?.id}/dashboards/${dashboardSummary?.id}`);
                            }}>
                                <td>{LoadShortDate(dashboardSummary.dateCreated)} {LoadShortTime(dashboardSummary.timeCreated)}</td>
                                <td>{dashboardSummary.title}</td>
                                <td>
                                    {extractAssignedCustomersString(dashboardSummary.customers)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
const Dashboards = () =>{
    const {user,customerIotProfile,logout} = useContext(AppContext);
    const {
        dashboardSummaries,setDashboardSummaries
    } = useContext(DashboardContext);
    const logoutTimerRef = useRef(null);
    const navigate = useNavigate();
    const [dashboardsPageLimit,setDashboardsPageLimit] = useState(20);
    const [dashboardsCurrentPage,setDashboardsCurrentPage] = useState(1);
    const [dashboardsCount,setDashboardsCount] = useState(0);
    const [dashboardsFetched,setDashboardsFetched] = useState(false);
    const [dashboardsOrdered,setDashboardsOrdered] = useState(false);
    const fetchDashboardsPage = async(page) =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/customers/users/admin/${customerIotProfile?.id}/dashboards?page=${page}&limit=${dashboardsPageLimit}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                return responseData;
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when fetching dashboards:',error);
        }
        return [];
    };
    const fetchAndSetDashboards = async() =>{
        try{
            setDashboardSummaries([]);
            const localDashboardsCount = await fetchDashboardsCount();
            const totalPages = Math.ceil(localDashboardsCount / dashboardsPageLimit);
            let pagesLoaded = 0;
            if(!localDashboardsCount || localDashboardsCount <= 0){
                return;
            }
            for(let page = 1;page <= totalPages;page++){
                fetchDashboardsPage(page).then((pageData) =>{
                    if(pageData && Array.isArray(pageData)){
                        setDashboardSummaries(prev => Array.isArray(prev)? [...prev,...pageData]:[...pageData]);
                    }
                }).catch(error =>{
                    console.error(`Error loading page ${page}:`,error);
                }).finally(() =>{
                    pagesLoaded++;
                    if(pagesLoaded === totalPages){
                        setDashboardsFetched(true);
                        setDashboardsOrdered(false);
                    }
                })
            }
        }
        catch(error){
            console.log('An error occurred when fetching all dashboards: ',error);
        }
    };
    const fetchDashboardsCount = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/customers/users/admin/${customerIotProfile?.id}/dashboards/count`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                return(isNaN(Number(responseData))? 0:Number(responseData));
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when fetching dashboards count: ',error);
        }
        return 0;
    };
    const getPagesAvailable = () => {
        return Math.ceil(dashboardSummaries?.length / dashboardsPageLimit);
    };
    useEffect(() =>{
        document.title = 'Blink IOT | Dashboards';
    },[]);
    useEffect(() =>{
        if(dashboardsFetched) return;
        if(!user){
            logoutTimerRef.current = setTimeout(() =>{
                navigate('/');
                window.location.reload();
            },10);
            return;
        }
        else{
            if(logoutTimerRef.current){
                clearTimeout(logoutTimerRef.current);
                logoutTimerRef.current = null;
            }
        }
        fetchAndSetDashboards();
        const updateDashboardCount = async () =>{setDashboardsCount(await fetchDashboardsCount());}
        updateDashboardCount();
    },[dashboardsFetched]);
    useEffect(() =>{
        if(!dashboardsFetched || !dashboardSummaries || dashboardsOrdered) return;
        setDashboardSummaries([...dashboardSummaries].sort((a,b) => a?.title?.localeCompare(b?.title)));
        setDashboardsOrdered(true);
    },[dashboardSummaries,dashboardsOrdered]);
    return(
        <div className="customer-admin-dashboards-page">
            <NavigationBar/>
            <div className="customer-admin-dashboards-page-layout">
                <div>
                    <CustomerAdministratorSideBar/>
                </div>
                <div className="customer-admin-dashboards-parent-container">
                    <div className="customer-admin-dashboards-container">
                        <div className="customer-admin-dashboards-header-container">
                            <h2>Dashboards</h2>
                            <div className="customer-admin-dashboards-header-controls">
                                <button className="customer-admin-refresh-dashboards-button" onClick={() =>{}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        {<DashboardsTable
                            dashboardSummaries={dashboardSummaries}
                            setDashboardSummaries={setDashboardSummaries}
                            dashboardsCurrentPage={dashboardsCurrentPage}
                            dashboardsPageLimit={dashboardsPageLimit}
                            fetchDashboards={fetchAndSetDashboards}
                        />}
                        <div className="customer-admin-dashboards-footer-container">
                            <div className="customer-admin-dashboards-page-limit-container">
                                <p>Items per page:</p>
                                <div>
                                    <select value={dashboardsPageLimit} onChange={(e) => setDashboardsPageLimit(e.target.value)}>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                    </select>
                                </div>
                            </div>
                            <div className="customer-admin-dashboards-page-info-container">
                                <p>
                                    {((dashboardsCurrentPage - 1) * dashboardsPageLimit) + 1} - {Math.min(dashboardsCurrentPage * dashboardsPageLimit,dashboardsCount)} of {dashboardsCount}
                                </p>
                            </div>
                            <div className="customer-admin-dashboards-page-navigator-container">
                                <p
                                    className={`first-page ${dashboardsCurrentPage === 1? 'inactive':''}`}
                                    title="First page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage <= 1) return;
                                        setDashboardsCurrentPage(1);
                                    }}>&#9198;</p>
                                <p
                                    className={`previous-page ${dashboardsCurrentPage === 1? 'inactive':''}`}
                                    title="Previous page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage <= 1) return;
                                        setDashboardsCurrentPage(dashboardsCurrentPage - 1);
                                    }}>&#9664;</p>
                                <p
                                    className={`next-page ${dashboardsCurrentPage === getPagesAvailable()? 'inactive':''}`}
                                    title="Next page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage === getPagesAvailable()) return;
                                        setDashboardsCurrentPage(dashboardsCurrentPage + 1);
                                    }}>&#9654;</p>
                                <p
                                    className={`last-page ${dashboardsCurrentPage === getPagesAvailable()? 'inactive':''}`}
                                    title="Last page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage === getPagesAvailable()) return;
                                        setDashboardsCurrentPage(getPagesAvailable());
                                    }}>&#9197;</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Dashboards;